<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar>
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:middleRight>

      </template>
      <template v-slot:right>
        <div class="d-flex align-center" style="margin-right: 10px">
          <span style="font-size: 19px;">{{ total }}件</span>
        </div>

      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <v-layout column fill-height>
          <v-flex grow>
            <div :class="$style['main-content']" class="table-responsive">
              <CDataTable
                  :items="entities"
                  :fields="columnsForTable"
                  hover
                  :loading="loading"
                  style="font-size: 15px !important;"
                  :noItemsView='{ noResults: "データが存在しません", noItems: loading ? "読込中" : "データが存在しません" }'
          >

            <template #status="{item}">
              <td>
                <span >
                  {{item.status === "new" ? "新規" : "編集"}}
                </span>
              </td>
            </template>
            <template #image_old="{item}">
              <td>
                <div><img style="max-width: 100px;max-height: 100px;" :src="item.image_old" /></div>
              </td>
            </template>
            <template #image="{item}">
                  <td>
                    <div><img style="max-width: 100px;max-height: 100px;" :src="item.image" /></div>
                  </td>
                </template>
          </CDataTable>
        </div>
          </v-flex>

          <v-flex :class="$style['container-footer']">
            <v-toolbar>
            <CButton class="mx-1" color="primary" :disabled="entities.length < 1" @click="onCreate">
              保存
            </CButton>
              <CButton class="mx-1" color="primary" @click="onBack">
                キャンセル
              </CButton>
            </v-toolbar>
          </v-flex>

          </v-layout>
      </v-content>
    </div>
    <FilterModal :resourceName="resourceName" :columns="columns" />
  </v-container>
</template>

<script>
import ToolBar from "@/components/app/toolbar";
import FilterModal from "@/components/filter-modal";
import utility from "@/utility";
import RemoveAction from "@/components/view/actions/remove";
import DetailAction from "@/components/view/actions/detail";
import Breadcrumb from "@/components/app/breadcrumb";
import PasswordReissueDialog from "@/components/dialogs/password-reissue-dialog";
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    ToolBar,
    Breadcrumb,
    RemoveAction,
    DetailAction,
    FilterModal,
    PasswordReissueDialog
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    pk: {
      type: String,
      default: "id"
    },
    disabledAddButton: {
      type: Boolean,
      default: false
    },
    disabledFilterButton: {
      type: Boolean,
      default: true
    },
    disabledPagination: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  computed: {
    loading() {
      return this.$store.getters[`${this.resourceName}/csv/isLoading`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/csv/isProcessing`];
    },
    entities() {
      return this.$store.getters[`${this.resourceName}/csv/entities`];
    },
    total() {
      return this.$store.getters[`${this.resourceName}/csv/total`];
    },
    columnsForTable() {
      let columnFiltered = this.columns.filter(column => {
        return !(column.isProvider && !this.isProvider);
      });

      let columns = columnFiltered.map(column => {
        if(!(column.isProvider && !this.isProvider)) {
          return {
            key: column.value,
            label: column.text,
            filter: column.filter === undefined ? true : column.filter,
            sorter: column.sorter === undefined ? true : column.sorter,
            _style: 'width:' + column.width + ';',
            // filterable  : column.filterable,
            // divider     : true,
            // class       : column.class,
          };
        }
      });

      return [
        ...columns
      ];
    },
    disablePublishButton(){
      return this.selected.length < 1;
    },
    disableDeleteButton(){
      return this.selected.length < 1;
    }
  },
  watch: {
  },
  methods: {
    onCreate() {
      utility
        .$confirm("一括登録を実行しますか？", "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/csv/exec`, {})
            .then(() => {
              this.$store.commit(`${this.resourceName}/csv/clear`);
              this.$router.back();
            });
        })
        .catch(() => {
        });
    },
    onBack() {
      this.$store.commit(`${this.resourceName}/csv/clear`);
      this.$router.back();
    },
    onHeaderClick(columnClicked) {
      if (columnClicked.property === "buttons") {
        return;
      }

      const column = this.columns.find(
        column => column.name === columnClicked.property
      );

      if (!column.sortable) {
        return;
      }

      this.$store.commit(`${this.resourceName}/list/setSort`, {
        field: columnClicked.property,
        type: column.type || ""
      });

      this.fetch(this.currentPage);
    },
    getRowStyle(header) {
      return {
        diplay: "block",
        width: header.width + "px"
      };
    }
  },
  created() {
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-index-header-height: 55px;
$base-index-footer-height: 60px;

.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  position: relative;
  background-color: #fff;

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-index-header-height});

    .main-content {
      display: flex;
      position: relative;
      flex-direction: column;
      height: calc(
        100vh - #{$base-index-header-height} - #{$base-index-footer-height}
      );

      :global(.v-data-table.v-data-table--fixed-header) {
        width: 100%;
        position: relative;
        height: calc(
          100vh - #{$base-index-header-height} - #{$base-index-footer-height}
        );

        :global(.v-data-table__wrapper) {
          height: 100%;
        }
      }

      th > div{
        width: max-content;
      }
    }
  }

  .container-footer{
    background-color: #fff;
  }

  .pagination {
    height: $base-index-footer-height !important;
  }
}

.control-button{
  width: 60px !important;
}

.toolbar-total {
  position: absolute;
  right: 300px;
}

.datepicker{
  div > input{
    border: 1px ridge #333333;
    display: block;
    margin: 5px 5px 10px;
  }
}
</style>
<style lang="scss">
  select{
    -moz-appearance: auto !important;
    -webkit-appearance: auto !important;
  }

  .form-check-input {
    width: 15px;
    height: 15px;
  }
</style>
